import { ComponentType, FC, ReactElement, ReactNode } from 'react';
import clsx from 'clsx';
import { Image } from '@namespace/icons2';
import { AText } from '../AText';
import { Box } from '../Box';

import styles from './index.module.css';

interface ClassNames {
  containerClassName?: string;
  textClassName?: string;
  subTextClassName?: string;
}

interface EmptyStateProps {
  dataRolePrefix?: string;
  text: string | ReactElement;
  subText?: string;
  linkPath?: string;
  linkText?: string;
  className?: string;
  classNames?: ClassNames;
  image?: ReactNode;
  Link?: ComponentType<{
    to: string;
    className?: string;
    children?: ReactNode;
  }>;
}

export const EmptyState: FC<EmptyStateProps> = ({
  dataRolePrefix,
  text,
  subText = '',
  linkPath = '',
  linkText = '',
  className,
  classNames = {},
  image,
  Link
}) => (
  <Box
    data-role={
      dataRolePrefix
        ? `${dataRolePrefix}empty-state-wrapper`
        : 'empty-state-wrapper'
    }
    className={clsx(styles.wrapper, className)}
  >
    <Box
      align="center"
      justify="center"
      direction="column"
      className={clsx(styles.empty, classNames.containerClassName)}
    >
      {image || (
        <Image name="general/looking_for" width="64px" height="64px" alt="" />
      )}
      <AText
        breed="BU"
        size="m"
        className={clsx(styles.text, classNames.textClassName)}
      >
        {text}
      </AText>
      {subText && (
        <AText
          breed="R"
          size="m"
          className={clsx(styles.subText, classNames.subTextClassName)}
        >
          {subText}
        </AText>
      )}
      {linkText && Link && (
        <Link
          to={linkPath}
          className={clsx(
            styles.homeLink,
            styles.text,
            classNames.textClassName
          )}
        >
          {linkText}
        </Link>
      )}
    </Box>
  </Box>
);
